import React from "react";
import { useScript } from "usehooks-ts";

interface Props {
  url: string;
}
export const ChaseIFrame = ({ url }: Props) => {
  const status = useScript(
    "https://chase-var.hostedpaymentservice.net/includes/hpfParent.min.js",
  );

  if (status === "loading") return "Loading payment gateway...";

  return (
    <iframe
      id="hpfFrame"
      title="Chase Payment"
      src={url}
      height="400px"
      width="100%"
    />
  );
};
